import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-unresolved
import { Scrollbar, Navigation, FreeMode, Mousewheel } from "swiper/modules";
import {
  Swiper,
  SwiperSlide,
} from "swiper/react"; /* eslint-disable-line import/no-unresolved */
import classnames from "classnames";

import Button from "../Button";

import "swiper/css"; /* eslint-disable-line import/no-unresolved */
import "./Slider.scss";

const Slider = ({ className, children }) => {
  const [reachEnd, setReachEnd] = useState(false);
  const scrollbarRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const swiperOnInit = (swiper) => {
    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;
    swiper.params.scrollbar.el = scrollbarRef.current;
    swiper.navigation.init();
    swiper.navigation.update();
    swiper.scrollbar.init();
    swiper.scrollbar.updateSize();
  };

  return (
    <Swiper
      className={classnames(className, {
        "background-fade": !reachEnd,
      })}
      direction="horizontal"
      slidesPerView="auto"
      freeMode={{ enabled: true, momentum: false }}
      init={false}
      mousewheel={false}
      modules={[Navigation, Scrollbar, FreeMode, Mousewheel]}
      scrollbar={{
        el: scrollbarRef.current,
        draggable: false,
      }}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      onInit={swiperOnInit}
      onReachEnd={() => {
        setReachEnd(true);
      }}
      onReachBeginning={() => {
        setReachEnd(false);
      }}
    >
      <SwiperSlide className="slider__slide">{children}</SwiperSlide>
      <div className="slider__controls">
        <div className="slider__controls__navigation">
          <Button
            ref={prevRef}
            variant="outline"
            iconName="system-chevron-left-small"
            className="slider__controls__button"
            aria-label="Scroll to the start"
          />
          <Button
            ref={nextRef}
            variant="outline"
            iconName="system-chevron-right-small"
            className="slider__controls__button"
            aria-label="Scroll to the end"
          />
        </div>
        <div ref={scrollbarRef} className="slider__controls__scrollbar" />
      </div>
    </Swiper>
  );
};

Slider.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Slider;
